module.exports = __webpack_public_path__ + "img/dragndrop.49080909.svg";